/**
 * shell/sessionTime.ts —— 会话行时间文案（真源逐字：102 `utils/sessionGroups.js::formatSessionTime`）。
 *
 * 口径：缺时间 ⇒ **空串**（时间位不渲染＝如实留空，不补造）；今日／昨日带 `HH:MM`，更早给 `MM-DD`。
 * 纪律：纯函数、可注入 `now`（确定性）；本件零取数、零依赖。
 */
export function formatSessionTime(raw: string | null | undefined, now: number = Date.now()): string {
  const value = typeof raw === "string" ? raw.trim() : "";
  if (!value) return "";
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return "";
  const pad = (n: number): string => (n < 10 ? "0" + n : String(n));
  const hhmm = pad(at.getHours()) + ":" + pad(at.getMinutes());
  const today = new Date(now);
  const isSameDay = at.getFullYear() === today.getFullYear()
    && at.getMonth() === today.getMonth() && at.getDate() === today.getDate();
  if (isSameDay) return "今天 " + hhmm;
  const yesterday = new Date(today.getTime() - 86400000);
  const isYesterday = at.getFullYear() === yesterday.getFullYear()
    && at.getMonth() === yesterday.getMonth() && at.getDate() === yesterday.getDate();
  if (isYesterday) return "昨天 " + hhmm;
  return pad(at.getMonth() + 1) + "-" + pad(at.getDate());
}
